const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const withState = require('../../../../../../../utils/withState');
const TextFieldK = require('../../../../../TextField/K');

module.exports = withState((setState, self, onMount) => {
  let _cancel = noop;
  let _search;

  function handleChangeSearchWithReDelay(search) {
    _cancel();
    _cancel = delay(() => {
      const {
        props,
      } = self;
      props.onChange({
        ...props.data,
        search,
      });
    }, 500);
  }
  function handleChangeSearch(e) {
    const searchValue = e.target.value || null;
    setState({
      searchValue,
    });
    handleChangeSearchWithReDelay(searchValue);
  }
  function update() {
    _cancel();
    _cancel = delay(setState, 0, [{
      searchValue: _search,
    }]);
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  return (state, props) => {
    const {data = {}, searchComponent, disabled} = props;

    const search = data.search;
    const Input = searchComponent || TextFieldK;

    _search === search || update(_search = search);

    const searchValue = state.searchValue || '';
    const s = props.search || {};
    const className = s.className || 'w249';
    const searchPlaceholder = s.placeholder || 'Search';
    const maxLength = s.maxLength || 150;

    return (
      <Input
        className={className}
        placeholder={searchPlaceholder}
        value={searchValue}
        onChange={handleChangeSearch}
        disabled={disabled}
        maxLength={maxLength}
      />
    );
  };
});
